export const getPrimaryPlacement = (placement) => {
    switch (placement) {
        case 'bottom':
        case 'bottom-start':
        case 'bottom-end':
            return 'bottom';
        case 'top':
        case 'top-start':
        case 'top-end':
            return 'top';
        case 'right':
        case 'right-start':
        case 'right-end':
            return 'right';
        case 'left':
        case 'left-start':
        case 'left-end':
            return 'left';
        case 'auto':
        case 'auto-start':
        case 'auto-end':
        case undefined:
            return undefined;
    }
};
//# sourceMappingURL=get_primary_placement.js.map